<template>
	<v-row class="page-header-left app--page-header justify-center">
		<v-col class="d-flex align-center flex-column pt-5 pb-0">
			<div class="page-title-container">
				<span class="page-title">{{ $route.meta.title || "" }}</span>
				<v-tooltip v-if="has_tooltip" bottom max-width="400">
					<template v-slot:activator="{ on, attrs }">
						<span
							v-bind="attrs"
							v-on="on"
							class="tooltip-icon ml-2"
						>ℹ️</span>
					</template>
					<span class="tooltip-content">{{ tooltip_text }}</span>
				</v-tooltip>
			</div>
			<span class="sec-font-color sub-title">{{ $route.meta.parentTitle }}</span>
			<SavePinConfirmBtn v-if="showPinConfirmBtn()" :getRoute="route" />
		</v-col>
	</v-row>
</template>

<script>
import SavePinConfirmBtn from '@/components/SavePinConfirmBtn';

export default {
	components: {
		SavePinConfirmBtn,
	},

	data() {
		return {
			title: 'Home',
			breadcrumbs: [],
			route: '',
		};
	},

	computed: {
		menu_key() {
			return this.$route.meta.menu_key || '';
		},

		tooltip_text() {
			return this.menu_key ? this.$i18n.tmenu_desc(this.menu_key) : '';
		},

		has_tooltip() {
			return this.menu_key && this.$i18n.has_menu_desc(this.menu_key);
		}
	},

	watch: {
		'$route.path'(newVal) {
			this.computeBreadcrumbs();
			this.route = newVal;
		},
	},

	methods: {
		computeBreadcrumbs() {
			const breadcrumbs = [
				{
					text: 'Home',
					href: '/',
					disabled: false,
				},
			];

			const appends = this.$route.matched.map((item) => ({
				text: item.meta.title || '',
				href: item.path || '/',
				group: item.group,
				disabled: item.path === this.$route.path,
			}));

			this.breadcrumbs = breadcrumbs.concat(appends);
		},

		showPinConfirmBtn() {
			if (this.route.indexOf('maintenance') !== -1) {
				return false;
			}
			if (this.$route.name === 'Dashboard') {
				return false;
			}
			return true;
		},
	},

	created() {
		this.computeBreadcrumbs();
	},
};
</script>
<style lang="stylus" scoped>
.disabled
  color grey
  pointer-events none
  text-decoration blink

.app--page-header
  padding-top 45px

.page-title-container
  display flex
  align-items center
  justify-content center

.tooltip-icon
  cursor help
  opacity 0.7
  font-size 18px
  color #9e9e9e
  user-select none
  transition opacity 0.2s ease

  &:hover
    opacity 1

.tooltip-content
  font-size 14px
  line-height 1.6
  white-space normal
  display block
</style>
